export default [
  { label: 'None', value: 'none' },
  { label: 'When added to Schola® System', value: 'add_schola_system' },
  { label: 'Birthday', value: 'birthday' },
];
